import React from 'react';
import {connect} from 'react-redux';
import {injectIntl} from "react-intl";

import MobileNavigationCommon from "../../visComponents/navigation/mobileNavigationCommon";

import {ContentType} from "../../visComponents/constants";
import Z from "../core/zIndex";

import MobileNavigationButtons from '../../visComponents/navigation/mobile/mobileNavigationButtons';
import MobileNavigationAllWallsCheckbox from '../../visComponents/navigation/mobile/mobileNavigationAllWallsCheckbox';
import FeatureWizardSteps from "../../visComponents/navigation/featureWizard/featureWizardSteps";

import {changeActivePartRelatedItemIndex, setDefaultSelectionGroup} from "../../../actions/actionFunctions";
import {
  setActiveNavigationFilter,
  setModuleContextMenuType,
  setModuleContextMenuModule,
  setActiveNavigationFilterStepIndex, setNavigationViewType, setNavigationLoading, toggleNavItemPositionModal
} from "../../../actions/navigationFunctions";

import MobileMenuSelect from '../../visComponents/navigation/mobile/mobileMenuSelect';
import LockedView from "../../common/lockedView";

import Filters from "../../visComponents/navigation/newFilters/filters";
import BodyPanelRadio from "../../visComponents/navigation/desktop/bodyPanelRadio";
import FilterSwitchers from "../../visComponents/navigation/newFilters/filterSwitchers";
import FilterSelection from "../../visComponents/navigation/newFilters/filterSelection";
// import {CABINET_WIZARD_BUTTONS} from "../core/constants";
import NavigationFiltersSteps from "../../visComponents/navigation/newFilters/navigationFiltersSteps";
import ContextMenu from "./contextMenu";

import {getCurrentLayout} from "../../appLayout";
import {COUNTERTOP_GROUP_BATHROOM} from "../core/constants";
import CountertopSwitchers from "../../kvComponent/navigation/countertopSwitchers";
import {Vanity} from "../core/parts/vanity";
import NavItemPositionModal from "../../visComponents/navigation/navItemPositionModal";
import LookAllWallsRadioButton from "../../look/lookNavigation/lookMain/lookAllWallsRadioButton";

class MobileNavigation extends MobileNavigationCommon {

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._UNSAFE_componentWillReceiveProps(nextProps)
  }

  bindCanvasClick = (event) => {
    const layout = getCurrentLayout();
    // const canvas = document.getElementById(this.props.canvasId);

    if (!window.touchMove && !this.state.showNavigation && !this.state.contextMenuOpen) {
      this.props.setHoveredLayer(event);
    }

    if (document.hoveredLayer && !window.touchMove) {
      // $('.canvas-text').html(`CLICK3`);
      const layoutType = layout.getCurrentLayoutName();

      const hoveredZone = Z.getMenuByHoveredLayer(layoutType, document.hoveredLayer);
      let ponyWallGroup = false;

      if (hoveredZone) {
        if ((hoveredZone === "shower_custom" || hoveredZone === "vanity_custom" || hoveredZone === "bathtub_custom"
          || hoveredZone === "shower_combo" || hoveredZone === "shower_pony_wall" || hoveredZone === "left_wall_custom"
          || hoveredZone === "wall_b_custom") && !this.state.showNavigation) {
          if (this.state.contextMenuOpen) {
            this.setState({
              contextMenuOpen: false,
              hoveredLayer: {}
            });
            document.removeEventListener('click', this.handleContextMenuBlur);
          } else {
            let contextMenuOpen = '';
            switch (hoveredZone) {
              case "shower_custom":
              case "shower_combo":
              case "shower_pony_wall": {
                const showerGroup = this.state.designNavigationItems.find(navItem => {
                  return navItem.text === "Shower"
                });
                contextMenuOpen = showerGroup.part.showerTubComboIsActive() ? "Shower Tub Combo" : "Shower";
                if (hoveredZone === "shower_pony_wall") {
                  ponyWallGroup = true;
                }
                break;
              }
              case "vanity_custom":
                contextMenuOpen = "Vanity";
                break;
              case "bathtub_custom":
                contextMenuOpen = "Bathtub";
                break;
              case "left_wall_custom":
                contextMenuOpen = "Shower Body Selection";
                break;
              case "wall_b_custom":
                contextMenuOpen = "wall_b_custom";
                break;
            }
            this.setState({
              contextMenuOpen,
              contextMenuPonyWall: ponyWallGroup,
              hoveredLayer: document.hoveredLayer
            }, () => {
              if (contextMenuOpen) {
                setTimeout(() => {
                  document.addEventListener('click', this.handleContextMenuBlur);
                }, 0)
              }
            });
          }
          return false;
        } else if (this.state.contentType === 0) {
          if (!window.canvasIsDragging) {
            this.props.setCanvasClass((hoveredZone.child || hoveredZone.parent || hoveredZone).toLowerCase().replace(/ /g, "-"));
          }
          this.openMobileMenu();
        }

        hoveredZone.child
          ? this.triggerOpenNavigationMenu(hoveredZone.child, hoveredZone.parent, ponyWallGroup)
          : this.triggerOpenNavigationMenu(hoveredZone)

      }

    }

  };

  handleNavigationItemClick = (item, ignoreLocked = false, featureIsLocked, event) => {
    const layout = getCurrentLayout();
    //console.log('item', item);

    if (this.state.childNavigationItem
      && this.state.childNavigationItem.part.activeFeature
      && Array.isArray(this.state.childNavigationItem.part.activeFeature.metaData["SkuName"])
      && this.state.childNavigationItem.part.activeFeature.metaData["SkuName"][0]
      && Array.isArray(item.part.metaData["SkuName"])
      && (this.state.childNavigationItem.part.activeFeature.metaData["SkuName"][0] === item.part.metaData["SkuName"][0])) {
      this.showPositionsPopup(item, event); // move modal to new position
      return false // don't change L to R // redundant click
    }

    const showPositionPopup = this.showPositionsPopup(item, event);
    if (showPositionPopup) {
      this.props.setActiveFeature(item.part); // set feature for modal
      return // don't click on feature!! we are clicking inside the modal window
    }

    if (item.matchesMetaFailed) {
      let nonCompatibleWith = "";
      switch (item.part.partId) {
        case "vanity_faucet":
          nonCompatibleWith = "sink";
          break;
        case "sink":
          nonCompatibleWith = "vanity";
          break;
        case "shower_pod":
          nonCompatibleWith = "Window Kit";
          break;
        case "window_kits":
          nonCompatibleWith = item.matchesMetaFailed === "shower_pod" ? "Shower Pod" : "Corner Shelf";
          break;
        default:
          break;
      }
      this.callMetaMathesFailedPopup(item, nonCompatibleWith);
    } else if (item.part.partId === "vanity_sink" && this.state.parentNavigationItem.part.faucet.placeholderChanged
      && this.state.parentNavigationItem.part.faucet.activeFeature) {
      const sinkSizeConditionValue = item.part.metaData["SinkSize"][0];
      if (this.state.parentNavigationItem.part.faucet.activeFeature.matchesMetaForCondition('SinkSize', sinkSizeConditionValue)) {
        this.itemClick(item, ignoreLocked)
      } else {
        this.callMetaMathesFailedPopup(item, 'faucet');
      }
    } else if (item.part.partId === "toilet") {
      const vanity = layout.parts[Vanity.id];
      const counterTopSize = vanity.counterTopSize();
      if (counterTopSize === "60in" || counterTopSize === "72in") {
        this.callToiletFailPopup('toilet', item, ignoreLocked)
      } else {
        this.itemClick(item, ignoreLocked)
      }
    } else if (item.part.partId === "vanity_cabinet") {
      // let toilet = layout.parts[Toilet.id];
      // if (toilet) {
      //   toilet = toilet.toilet; // toiletBody
      // }
      // const counterTopSize = item.part.vanitySize + 'in';
      // const vanity = layout.parts[Vanity.id];
      // const currentCounterTopSize = vanity.counterTopSize();
      // if (toilet && toilet.placeholderChanged && (counterTopSize === "60in" || counterTopSize === "72in")
      //   && (currentCounterTopSize !== "60in" && currentCounterTopSize !== "72in")) {
      //   this.callToiletFailPopup('vanity', item, ignoreLocked)
      // } else {
      //   this.itemClick(item, ignoreLocked)
      // }
      this.itemClick(item, ignoreLocked);
      if (this.props.fabricatorSettings
        && (this.props.fabricatorSettings.wizardConsumers || (this.props.fabricatorSettings.wizardClients && document.kvConfig.isBackend))
      ) {
        if (!featureIsLocked && !item.part.partName.includes("laceholder")) {
          this.setWizardFiltersFromActiveItem(item.part)
        }
      }
    } else if (item.part.partId === "shower_interior_wall") {
      if (!featureIsLocked && !item.part.partName.includes("laceholder")) {
        this.setWizardFiltersFromActiveItem(item.part)
      }
      this.itemClick(item, ignoreLocked)
    } else {
      this.itemClick(item, ignoreLocked)
    }

    this.props.setActiveFeature(item.part);

    const canvasClass = this.state.childNavigationItem
      ? this.state.parentNavigationItem.text + '-' + this.state.childNavigationItem.text
      : this.state.parentNavigationItem.text;

    if (!window.canvasIsDragging) {
      this.props.setCanvasClass(canvasClass.toLowerCase().replace(/ /g, "-"));
    }

    if (this.state.parentNavigationItem) {  // update canvas only if it is child
      this.props.refreshCB();
    }
  };

  handleSubPartClick = subNavigationItem => { // sidebar list item click
    const subItemPart = subNavigationItem.part;
    subItemPart.getParent().handleSubPartClick(subItemPart);
    this.setState({
      childNavigationItem: subNavigationItem,
      showFilterSelection: subItemPart.allFeaturesReceived, // show filters only if subItemPart has all features
      showerWallWizardGroupsSelected: false,
      searchText: ""
    }, () => {
      this.scrollContentToTop();
      this.rememberWallsSelection();
      this.checkIfAllFeaturesReceived(subNavigationItem, "childNavigationItem");
    });
    /*set new materials page subIndex*/
    this.setActivePartRelatedItemIndex(subNavigationItem);
    // console.log('subItemPart', subItemPart);
    if ((subItemPart.getParent() && subItemPart.getParent().partName === "Walls")
      || subItemPart.partName === "Accent Wall" && !window.canvasIsDragging) {
      this.props.setCanvasClass(subNavigationItem.text.toLowerCase().replace(/ /g, "-"));
    }
    this.setNewActiveFeature(subNavigationItem);
  };

  render() {
    const layout = getCurrentLayout();
    const activePart = this.state.parentNavigationItem ? this.state.parentNavigationItem.part : null;
    const activeSubPart = this.state.childNavigationItem ? this.state.childNavigationItem.part : null;
    const activeNavPart = activeSubPart || activePart;
    const parentItems = layout.designNavigationItems();  // parent list without filters
    const allFeaturesReceived = activeNavPart && activeNavPart.allFeaturesReceived;

    // console.log('activePart', activePart);
    // console.log('activeSubPart', activeSubPart);
    // console.log('activePart.subTypes()', activePart && activePart.subTypes());
    // console.log('this.state.childNavigationItemv1111', this.state.childNavigationItem);

    let useWizard = false;
    let wizardGroups = [];
    if (this.props.fabricatorSettings
      && (this.props.fabricatorSettings.wizardConsumers || (this.props.fabricatorSettings.wizardClients && document.kvConfig.isBackend))
      && this.state.contentType === ContentType.Design && activeSubPart && activeSubPart.canUseWizard && activeSubPart.allFeaturesReceived) {
      useWizard = true;
      wizardGroups = this.state[this.getWizardGroupsByPartId(this.state.childNavigationItem.part.partId)];
    }

    const features = this.getFeatures(layout);

    const showLockedView = this.currentActiveItemIsLocked(useWizard);

    const useFilters = (activePart && activePart.partId === "kitchen_floor" && activePart.allFeaturesReceived)
      || (activeSubPart && (this.isWallItem(activeSubPart) || activeSubPart.partId === "accent_wall"
        || activeSubPart.partId === "shower_wall_accent") && activeSubPart.allFeaturesReceived);

    const filterSelectionHasValues = activeNavPart && FilterSelection.getAvailableFilterValues(
      this.props.filterGroups, "Material", activeNavPart, this.props.fabricatorData
    ).length;

    const itemIsSelected = (!this.props.fabricatorSettings.leadCapture
      || (activeSubPart && activeSubPart.activeFeature && activeSubPart.firstClick[this.props.activeQuoteIndex] && activeSubPart.placeholderChanged));

    const useKVWizard = false;
    //TODO change it when BE is ready

    const showNavigationFilters = useKVWizard &&activeNavPart
      // && this.props.activeNavigationFilter !== CABINET_WIZARD_BUTTONS[0].buttonId
      && activeNavPart.canUseNavigationFilter && activeNavPart.canUseNavigationFilter();

    let showNavigationFiltersSteps = false;
    if (useKVWizard && activeNavPart && activeNavPart.canUseNavigationFilterSteps
      && activeNavPart.canUseNavigationFilterSteps()) {
      showNavigationFiltersSteps = !this.props.countertopNavigationFilterCompleted;
    }

    const isCountertop = activeSubPart && COUNTERTOP_GROUP_BATHROOM.includes(activeSubPart.partId);
    // console.log("isCountertop", isCountertop);

    return (
      <div className={"menu-wrapper"
      + (this.state.showNavigation || this.state.contextMenuOpen ? " menu-overlay--fullwidth" : "")}>
        <div className={"menu" + (this.state.showNavigation ? " menu--opened" : "")}>
          {/*<button className="menu-opener" onClick={this.toggleMobileMenu}/>*/}
          <div className={"menu-inner" + (this.state.searchInputFocused ? " menu-inner--search-input-focused" : "")}>
            <div className="menu-header">
              <div
                className={"menu-header__left"
                + (this.state.childNavigationItem ? " menu-header__left--with-border" : "")
                + (isCountertop ? " menu-header__left--with-countertops" : "")}>
                {this.state.childNavigationItem && this.state.childNavigationItem.part.canBeDisabled ? (
                  <BodyPanelRadio updateRadio={this.state.updateRadio}
                                  isMobile={true}
                                  activeSubPart={this.state.childNavigationItem.part}
                                  handleRadioButtonClick={this.handleRadioButtonClick}/>
                ) : null}
                {activeSubPart && isCountertop
                  ? layout.isNewLayout
                    ? <LookAllWallsRadioButton lookFeature={activeSubPart.activeFeature}/>
                    : <CountertopSwitchers isMobile={true} activeSubPart={activeSubPart}/>
                  : null}
                {activeSubPart && this.isWallItem(activeSubPart) && activeSubPart.partName !== "Accent Wall"
                  ? <MobileNavigationAllWallsCheckbox
                    parentNavigationItem={this.state.parentNavigationItem}
                    toggleApplyWallsCheckbox={this.toggleApplyWallsCheckbox}/>
                  : null}
              </div>
              <MobileNavigationButtons contentType={this.state.contentType}
                                       searchText={this.state.searchText}
                                       canvasId={this.props.canvasId}
                                       parentNavigationItem={this.state.parentNavigationItem}
                                       handleSearchInputChange={this.handleSearchInputChange}
                                       changeMessageBoxState={this.props.changeMessageBoxState}
                                       resetEverything={this.resetEverything}
                                       userIsLoggedIn={this.props.userIsLoggedIn}
                                       toggleUserPopup={this.props.toggleUserPopup}
                                       handleChangeContentType={this.handleChangeContentType}/>
            </div>
            {useFilters && this.state.showFilterSelection && filterSelectionHasValues
            && (this.state.contentType === ContentType.Design) ? (
              <FilterSelection removeFilterSelection={this.removeFilterSelection}
                               filterGroupName="Material"
                               activePart={activeNavPart}
                               isMobile={true}
              />
            ) : (
              this.state.showFeatureWizard ? (
                useWizard && this.state.childNavigationItem && this.state.childNavigationItem.part
                  ? this.contentDesignWizard()
                  : this.contentBody(features, showNavigationFilters || showNavigationFiltersSteps, useFilters, activePart, activeSubPart, filterSelectionHasValues, allFeaturesReceived)
              ) : this.contentBody(features, showNavigationFilters || showNavigationFiltersSteps, useFilters, activePart, activeSubPart, filterSelectionHasValues, allFeaturesReceived)
            )}
            {useWizard && !this.state.showFeatureWizard && !useFilters
            && (this.state.contentType === ContentType.Design) ? (
              <FeatureWizardSteps
                availableSteps={wizardGroups.filter(step => !step.hidden)}
                featureWizardStep={this.state.wizardStepIndex}
                setFeatureWizardStep={this.setWizardStepIndex}
                exitFeatureWizard={this.exitFeatureWizard}
                getFilterDisplayName={this.getFilterDisplayName}
                isMobile={true}
                isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                allProducts={true}
                showFeatureWizard={this.state.showFeatureWizard}
                enableFeatureWizard={this.enableFeatureWizard}
                toggleWizardFilterSelection={this.toggleWizardFilterSelection}
                allStepsCompleted={wizardGroups.every(step => step.selectedValueId) || itemIsSelected}
              />
            ) : null}
            {showNavigationFilters || showNavigationFiltersSteps ? (
              <NavigationFiltersSteps
                activePart={activeNavPart}
                isMobile={true}
              />
            ) : null}
            {useFilters && !this.state.showFilterSelection && filterSelectionHasValues ? (
              <FilterSwitchers activePart={activeNavPart} filterGroupName="Material" isMobile={true}/>
            ) : null}
            {this.state.contentType === ContentType.Design && this.state.parentNavigationItem
            && !(useWizard || showNavigationFilters || showNavigationFiltersSteps || (useFilters && filterSelectionHasValues)) ? (
              <MobileMenuSelect parentItems={parentItems}
                                activePart={activePart}
                                activeSubPart={activeSubPart}
                                onSubPartClick={this.handleSubPartClick}
                                onParentItemClick={this.handleParentItemClick}/>
            ) : null}
          </div>
        </div>
        {this.state.contextMenuOpen && !this.state.contextMenuOpen.module
          ? <ContextMenu contextMenuOpen={this.state.contextMenuOpen}
                         hoveredLayer={this.state.hoveredLayer}
                         designNavigationItems={this.state.designNavigationItems}
                         contextMenuPonyWall={this.state.contextMenuPonyWall}
                         handleContextMenuClick={this.handleContextMenuClick}
          />
          : null}
        {showLockedView
          ? <LockedView setActiveFeature={this.resetActiveFeature} handleUserLoginClick={this.handleUserLoginClick}/>
          : null}
        <Filters
          id="mobileNavigation"
          searchText={this.state.searchText}
          handleSearchInputChange={this.handleSearchInputChange}
          childItem={this.state.childNavigationItem}/>
        {this.props.bvOpened ? <NavItemPositionModal activeFeature={this.props.activeFeature}/> : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  fabricatorData: store.fabricatorState,
  selectedFilters: store.filterState.selectedFilters,
  filtersVisible: store.filterState.showFilters,
  filterGroups: store.filterState.filterGroups,
  bvPresets: store.bathroomVisualizerState.bvPresets,
  bvOpened: store.bathroomVisualizerState.bvOpened,
  userPopupOpened: store.userState.userPopupOpened,
  activeNavigationFilter: store.navigationState.activeNavigationFilter,
  countertopNavigationFilterCompleted: store.navigationState.countertopNavigationFilterCompleted,
  newLayoutType: store.sqftState.newLayoutType,
  countertopsApplyTo: store.navigationState.countertopsApplyTo,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
  navItemPositionModal: store.navigationState.navItemPositionModal,
});

const mapDispatchToProps = {
  setNavigationViewType,
  setModuleContextMenuType,
  setDefaultSelectionGroup,
  changeActivePartRelatedItemIndex,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setModuleContextMenuModule,
  setNavigationLoading,
  toggleNavItemPositionModal
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(MobileNavigation)
);
